import { render, staticRenderFns } from "./Rdygc.vue?vue&type=template&id=66be760c&scoped=true&"
import script from "./Rdygc.vue?vue&type=script&lang=js&"
export * from "./Rdygc.vue?vue&type=script&lang=js&"
import style0 from "./Rdygc.vue?vue&type=style&index=0&id=66be760c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66be760c",
  null
  
)

export default component.exports